type PluginConnectionAccessVisibilityInput = {
  isPluginAdmin: boolean;
  isBusinessGroupView: boolean;
  isConnectionActive: boolean;
  canManageConnectionAccess: boolean;
};

/**
 * Connection-level user access remains a Plugin Admin capability. Bustly Admin
 * delegates application access through Business groups instead.
 */
export const shouldShowPluginConnectionAccessAction = ({
    isPluginAdmin,
    isBusinessGroupView,
    isConnectionActive,
    canManageConnectionAccess,
}: PluginConnectionAccessVisibilityInput): boolean =>
    isPluginAdmin
    && !isBusinessGroupView
    && isConnectionActive
    && canManageConnectionAccess;

interface CanEditConnectionMemberAccessInput {
  isPluginAdmin: boolean;
  isConnectionOwnedByCurrentUser: boolean;
  isManagedByCurrentUser: boolean;
}

/**
 * Plugin connection owners always retain access to the member permission editor.
 * Bustly keeps using its existing resolved management permission unchanged.
 */
export const canEditConnectionMemberAccess = ({
  isPluginAdmin,
  isConnectionOwnedByCurrentUser,
  isManagedByCurrentUser,
}: CanEditConnectionMemberAccessInput): boolean =>
  isManagedByCurrentUser || (isPluginAdmin && isConnectionOwnedByCurrentUser);

interface CanEditConnectionMemberAccessTargetInput {
  isPluginAdmin: boolean;
  canEditMemberAccess: boolean;
  isConnectionOwnedByCurrentUser: boolean;
  isTargetConnectionOwner: boolean;
}

/**
 * A delegated Plugin manager can manage ordinary members, but the connection
 * owner remains the only person who can change the owner's own access.
 */
export const canEditConnectionMemberAccessTarget = ({
  isPluginAdmin,
  canEditMemberAccess,
  isConnectionOwnedByCurrentUser,
  isTargetConnectionOwner,
}: CanEditConnectionMemberAccessTargetInput): boolean => {
  if (!canEditMemberAccess) return false;
  if (!isPluginAdmin) return true;
  return isConnectionOwnedByCurrentUser || !isTargetConnectionOwner;
};
